import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import AcadamicsView from './AcadamicsView';

const CourseView = () => {
  return (
    <GlobalWrapper title={'Course View'}>
      <AcadamicsView />
    </GlobalWrapper>
  );
};

export default CourseView;
